<div class="attachement-month-header">
  <span *ngIf="year">
    {{'DATE.YEAR_MONTH' | translate: {'year': year, 'month':  month} }}
  </span>
  <span *ngIf="!year">
    {{month}}
  </span>
</div>